import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.394 11.03c0-.335.271-.606.606-.606h.006a.606.606 0 0 1 0 1.212H8a.606.606 0 0 1-.606-.606M7.337 5.74a1.212 1.212 0 0 1 1.826 1.047c0 .285-.221.582-.639.86a3.7 3.7 0 0 1-.755.381l-.01.003a.606.606 0 0 0 .384 1.15l-.192-.575.192.575h.002l.002-.002.007-.002.02-.007a3 3 0 0 0 .307-.124c.192-.085.451-.214.715-.39.491-.328 1.179-.94 1.179-1.867a2.424 2.424 0 0 0-4.71-.808.606.606 0 0 0 1.143.402c.095-.27.283-.497.53-.642"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.335 8a6.665 6.665 0 1 1 13.33 0 6.665 6.665 0 0 1-13.33 0M8 2.547a5.453 5.453 0 1 0 0 10.906A5.453 5.453 0 0 0 8 2.547",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })